import React from 'react';

import styled, { css } from 'styled-components';
import { StyledTypography, StyledBox, FlexContainer } from 'styles/common';
import { baseTheme } from 'themes/clients/baseTheme';

import { REVIEW_ANSWER_TYPE_MAP } from 'constants/ProjectConstants';
import { StyledIcon, StarIcon } from 'constants/icons';

const CircularIcon = styled(StyledIcon)`
  border-radius: 50%;
  padding: 1rem;
  ${(props) =>
    props.backgroundColor &&
    css`
      background-color: ${props.backgroundColor};
    `};
`;

const getOverallRating = (rating, ratingIsDropDown) => {
  const value = rating?.ratingSplit?.find((r) => r.type === 'OVERALL')?.value;
  return ratingIsDropDown ? value : parseFloat(value).toFixed(2);
};

const OverallRating = ({ rating, justifyContent = 'center' }) => {
  const ratingIsDropDown = rating?.ratingType === REVIEW_ANSWER_TYPE_MAP.DROP_DOWN;

  return (
    <StyledBox
      padding="2rem"
      flexcontainer
      justifycontent={justifyContent}
      alignitems="center"
      style={{ paddingTop: '0rem', paddingBottom: '3rem' }}
    >
      <CircularIcon backgroundColor="#E9F8FC" color="#0D819F" size="fixed24px">
        <StarIcon size="fixed12px" />
      </CircularIcon>
      <FlexContainer>
        <StyledTypography
          leftGutter={3}
          customColor={baseTheme.colors.text.g1}
          variant={ratingIsDropDown ? 'h5' : 'h3'}
          weight={600}
        >
          {getOverallRating(rating, ratingIsDropDown)}
        </StyledTypography>
        {!ratingIsDropDown && (
          <StyledTypography
            leftGutter={1}
            customColor={baseTheme.colors.text.g1}
            variant="h5"
            weight={600}
            style={{ alignSelf: 'flex-end', marginBottom: '0.25rem', fontSize: '20px' }}
          >
            / {parseFloat(rating?.maxOverallRating).toFixed(2)}
          </StyledTypography>
        )}
      </FlexContainer>
    </StyledBox>
  );
};

export default OverallRating;
